<template>
  <div class="ok-veridas-container">
    <div class="container w100 relative-container">
      <div class="padded">
        <wrap-container>
          <step-icon>
            <img src="../assets/img/1x/actions-success.svg" alt="Ícono éxito" />
          </step-icon>
          <p class="titulo p28 oscuro medium">¡Felicitaciones!</p>
          <p class="subtitulo oscuro">Validamos tus fotos exitosamente</p>
          <sales-button
            color="#1973B8"
            @click.native="avanzar"
            class="sales-button"
            label="Continuar"
            analyticsModule="identidad"
            analyticsSubmodule="biometria-ok"
          />
        </wrap-container>
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import StepIcon from "@/components/core/StepIcon.vue";
import SalesButton from "@/components/core/SalesButton.vue";

export default {
  name: "LoadingVeridas",
  components: {
    WrapContainer,
    StepIcon,
    SalesButton
  },
  mounted() {
    this.destroySdk();
  },
  methods: {
    avanzar() {
      this.$router.push(
        this.config.pasos[this.config.pasos.biometriaOK.pasoSiguiente].path
      );
    }
  }
};
</script>

<style scoped>
.ok-veridas-container {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.ok-veridas-container > .container {
  flex: 1;
  padding-top: 30px;
}
p {
  text-align: center;
  margin-left: 40px;
  margin-right: 40px;
}
.subtitulo {
  font-size: 16px;
  line-height: 1.4em;
}

.step-loader {
  margin: 50px -17px;
  width: auto;
}
.container.sales-button {
  height: 56px;
  width: 150px;
  display: block;
  margin-top: 40px;
}
</style>
